import Vue from 'vue';

/**
 * Le kit en cours de saisie, partagé par la composition et la synthèse que la tarification
 * sépare dans la carte. Les calculs doivent rester le miroir de KitComposition::summary().
 *
 * @see docs/DRI/Phase2/articles-composes.md § 8.2
 */
export default new Vue({
    data() {
        return {
            components: [],
            marginType: 1,
        };
    },
    computed: {
        selected() {
            return this.components.filter(component => component.article_id);
        },
        costTotal() {
            if (this.selected.some(component => component.unit_cost === null)) return null;

            return this.selected.reduce((total, component) => total + this.quantity(component) * component.unit_cost, 0);
        },
        sellingTotal() {
            return this.selected.reduce((total, component) => total + this.quantity(component) * (component.selling_price || 0), 0);
        },
    },
    methods: {
        quantity(component) {
            const quantity = parseFloat(component.quantity);

            return isNaN(quantity) ? 0 : quantity;
        },
        currency(value) {
            return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value || 0);
        },
    },
});
